<script>
export default {
  functional: true,
  render(
    h,
    {
      props: {
        option = { tooltips: {} },
        data = { person: {}, claz: {}, unit: {} }
      }
    }
  ) {
    const radarData = [
      { name: '创新思维', max: 25 },
      { name: '艺术分析', max: 25 },
      { name: '逻辑分析', max: 25 },
      { name: '编程技术', max: 25 }
    ]
    const legendData = ['个人', '班级', '学校']
    const colorMap = {
      person: '#FF8100',
      claz: '#2DADE3',
      unit: '#00C4AA'
    }
    const translate = {
      person: '个人',
      claz: '班级',
      unit: '学校'
    }
    const resultData = Object.entries(data).map(([k, v], i) => {
      return {
        name: translate[k],
        type: 'radar',
        lineStyle: {
          width: 2,
          opacity: 1
        },
        data: v ? [Object.values(v)] : [],
        symbol: 'none',
        itemStyle: {
          normal: {
            color: colorMap[k]
          }
        },
        areaStyle: {
          normal: {
            opacity: 0.3
          }
        },
        zlevel: 10
      }
    })
    option.tooltip = {
      formatter: function(parmas) {
        return `<div><div>创新思维：${parmas.value[0] *
          4}%</div><div>艺术分析：${parmas.value[1] *
          4}%</div><div>逻辑分析：${parmas.value[2] *
          4}%</div><div>编程技术：${parmas.value[3] * 4}%</div></div>`
      }
    }
    return (
      <radar-charts
        option={option}
        data={resultData}
        radar-data={radarData}
        legend-data={legendData}
      />
    )
  }
}
</script>
